import FirestoreDocument from "../../../types/FirestoreDocument";
import { nullable, record, ref, string, timestamp } from "../../../types/_types";

import { UserRef } from "../../users/types/User";

import { Article } from "./Article";
import { ArticleChannel } from "./ArticleChannel";

export const ArticleVersionChannel = ArticleChannel.pick({
	announcementDate: true,
	countries: true,
	deliveryTypes: true,
	prices: true,
	releaseDate: true,
	subChannels: true,
	takedownDate: true,
});

export const ArticleVersionData = Article.pick({
	abridged: true,
	accessibility: true,
	additionalLanguages: true,
	announcementDate: true,
	bisacCodes: true,
	bokgruppe: true,
	channelIds: true,
	contributors: true,
	countries: true,
	cover: true,
	duration: true,
	epubVersion: true,
	hazardsOrWarnings: true,
	imports: true,
	imprint: true,
	isbn: true,
	language: true,
	mainThemaCode: true,
	name: true,
	originalLanguage: true,
	originalName: true,
	pages: true,
	prices: true,
	producer: true,
	publisher: true,
	releaseDate: true,
	serie: true,
	serieNumber: true,
	status: true,
	subtitle: true,
	synopsis: true,
	tags: true,
	takedownDate: true,
	themaCodes: true,
	type: true,
	work: true,
}).extend({
	channels: record(string(), ArticleVersionChannel.partial()).default({}),
});

export const ArticleVersion = FirestoreDocument.extend({
	after: ArticleVersionData.catch(({ input }) => input),
	before: ArticleVersionData.catch(({ input }) => input),
	created: nullable(timestamp()),
	createdBy: nullable(UserRef),
});

export const ArticleVersionRef = ref(ArticleVersion, {
	created: true,
	createdBy: true,
});
